import React, { useEffect, useState } from 'react';

interface HTMLViewerProps {
  fileUrl: string;
  zoom: number;
}

const HTMLViewer: React.FC<HTMLViewerProps> = ({ fileUrl, zoom }) => {
  const [htmlContent, setHtmlContent] = useState<string>('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    const loadHTML = async () => {
      try {
        setLoading(true);
        setError('');

        const response = await fetch(fileUrl);
        const html = await response.text();
        setHtmlContent(html);
      } catch (err) {
        setError('Erreur lors du chargement du fichier HTML');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    loadHTML();
  }, [fileUrl]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center h-96">
        <p className="text-red-600">{error}</p>
      </div>
    );
  }

  return (
    <div
      className="bg-white p-8 rounded-lg shadow-sm"
      style={{ transform: `scale(${zoom / 100})`, transformOrigin: 'top center' }}
    >
      <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
    </div>
  );
};

export default HTMLViewer;
